import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1e88e5',  // açık mavi
    },
    secondary: {
      main: '#00c853',  // açık yeşil
    },
    background: {
      default: '#f5f5f5',  
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '25px',  
          textTransform: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff', 
          borderRadius: '5px',
        },
      },
    },
  },
});

export default theme;
